import React from 'react';
import './Header.css';

const Header = () => {

    return(
        <div className='header'>
            <h1>Welcome to Judoboy Trade!</h1>
            <h2>The Best Stock Trading& Investing App</h2>
            <h3>Switch from Robinhood, we credit you $300</h3>
        </div>
    )
}

export default Header;